import { useState } from "react";

const NewsletterSubscription = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log("Newsletter subscription:", email);
  };

  return (
    <section
      data-aos="zoom-in"
      data-aos-duration="2000"
      className="py-16 px-8 bg-white"
    >
      <div className="text-center">
        <p className="text-sm font-bold  text-[#113296] font-Outfit mb-2 tracking-wider uppercase">
          SUBSCRIBING
        </p>
        <div className=" text-center max-w-4xl mx-auto px-2 pt-2 pb-12 rounded-lg  border border-[#EBEAED]">
          <h2 className="text-2xl md:text-4xl lg:text-5xl px-10 font-bold text-[#113296] mb-12  leading-tight">
            Subscribe to our Newsletters for free eBooks and Articles.
          </h2>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto"
          >
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 px-6 py-4 rounded-full font-Outfit font-medium text-xl border border-[#EBEAED] text-[#15143966]/40 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              required
            />
            <button
              type="submit"
              className="bg-[#FF4B01] font-Outfit font-medium text-xl hover:bg-orange-600 text-white px-8 py-4 rounded-full transition-colors duration-200"
            >
              Sign Up
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSubscription;
